var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5296 5.17C12.8469 5.47329 12.8469 5.92821 12.5296 6.2315L8.24736 10.25C7.50722 10.9577 6.37056 9.89617 7.13714 9.18851L9.64836 6.81279C9.85983 6.6106 9.78053 6.45896 9.48976 6.45896L0.793016 6.45896C0.34364 6.45896 -6.22799e-08 6.1304 -5.71564e-08 5.70075C-5.20328e-08 5.2711 0.34364 4.94254 0.793016 4.94254L9.46332 4.94254C9.75409 4.94254 9.8334 4.7909 9.62192 4.58871L7.11071 2.21299C6.37056 1.50532 7.48078 0.418556 8.22093 1.15149L12.5296 5.17Z",
    fill: "#0071B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrow);
export default __webpack_public_path__ + "static/media/blue-arrow.afc223a9dc7d3f2c5af672802976f25e.svg";
export { ForwardRef as ReactComponent };